import { usePaginationParams } from 'hooks';
import { Outlet } from 'react-router-dom';
import { RefundRequestList } from '../component/refund-request-table/refund-request-list';
import { useGetRefundRequestList } from '../use-cases/get-refund-request';
import { RequestRefundTopBar } from '../component/top-bar/refund-request-topbar';
import { RefundRequestFormValues } from '../component/refund-request-filter-form/type';
import { useUserContext } from 'features/users';

const getInitialFilterValues: any = {
    UserName: undefined,
    EventName: undefined,
    MobileNumber: undefined,
    Status: undefined,
    FromDate: undefined,
    ToDate: undefined,
};

export const RefundRequestView = () => {
    const { user } = useUserContext();
    const { params, updateParams, resetPage } = usePaginationParams<any>({
        page: 1,
        size: 10,
        RollBy: user?.role,
        ...getInitialFilterValues,
    });
    const { data, refetch, isFetching } = useGetRefundRequestList(params, { retry: false });
    const handleFiltersChange = (values: RefundRequestFormValues) => {
        updateParams(values);
        resetPage();
        refetch()
    };

    return (

        <>
            <RequestRefundTopBar
                handleFilter={handleFiltersChange}
                getInitialFilterValues={getInitialFilterValues}
            // refetch={""}
            />
            <RefundRequestList
                isSocialListLoading={isFetching}
                DeliveryList={data}
                tableParams={params as any}
                updateParams={updateParams}
                refetch={refetch}

            />
            <Outlet />
        </>
    );
};
